import { render } from "./doubleAuthentication.vue?vue&type=template&id=09b73004&scoped=true"
import script from "./doubleAuthentication.vue?vue&type=script&lang=js"
export * from "./doubleAuthentication.vue?vue&type=script&lang=js"

import "./doubleAuthentication.vue?vue&type=style&index=0&id=09b73004&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b73004"]])

export default __exports__